import { marked } from 'marked'
import DOMPurify from 'dompurify'

/**
 * 统一的 Markdown → 安全 HTML 渲染。
 *
 * 所有要把 LLM/用户可影响内容放进 v-html 的地方必须走本函数:
 * marked 只做转换不做净化, 若不经过 DOMPurify, 恶意 prompt 引导 LLM
 * 输出的 <script>/<img onerror> 等将直接执行 (存储型 XSS, token 存于
 * localStorage 会被一并窃取)。
 */
export function renderMarkdown(md: string | null | undefined): string {
  if (!md) return ''
  const html = marked.parse(md, { breaks: true, async: false })
  return DOMPurify.sanitize(html as string)
}
